import { TimePeriod } from '@alberta/konexi-shared';
import { TranslateService } from '@ngx-translate/core';

const ADJECTIVE_KEYS: Partial<Record<TimePeriod, string>> = {
  [TimePeriod.Minute]: 'unknown',
  [TimePeriod.Hour]: 'hourly',
  [TimePeriod.Day]: 'daily',
  [TimePeriod.Week]: 'weekly',
  [TimePeriod.Month]: 'monthly',
  [TimePeriod.Quarter]: 'quarterly',
  [TimePeriod.HalfYear]: 'halfYearly',
  [TimePeriod.Year]: 'yearly',
};

const NOUN_KEYS: Partial<Record<TimePeriod, { base: string; hasDative: boolean }>> = {
  [TimePeriod.Minute]: { base: 'unknown', hasDative: false },
  [TimePeriod.Hour]: { base: 'hour', hasDative: false },
  [TimePeriod.Day]: { base: 'day', hasDative: true },
  [TimePeriod.Week]: { base: 'week', hasDative: true },
  [TimePeriod.Month]: { base: 'month', hasDative: true },
  [TimePeriod.Quarter]: { base: 'quarter', hasDative: false },
  [TimePeriod.HalfYear]: { base: 'halfYear', hasDative: false },
  [TimePeriod.Year]: { base: 'year', hasDative: true },
};

export function returnDurationText(
  translate: TranslateService,
  timePeriod: TimePeriod,
  plural?: boolean,
  dative?: boolean,
  adjective?: boolean
) {
  if (timePeriod == null) {
    return '';
  }

  if (adjective) {
    const key = ADJECTIVE_KEYS[timePeriod];
    return key ? translate.instant(`timePeriod.${key}`) : '';
  }

  const config = NOUN_KEYS[timePeriod];
  if (!config) {
    return '';
  }
  if (config.base === 'unknown') {
    return translate.instant(`timePeriod.unknown`);
  }
  const pluralSuffix = plural ? 's' : '';
  const dativeSuffix = dative && config.hasDative ? 'Dative' : '';
  return translate.instant(`timePeriod.${config.base}${pluralSuffix}${dativeSuffix}`);
}
